import { render, staticRenderFns } from "./OrderOfferMap.vue?vue&type=template&id=5b4ba8d8&scoped=true"
import script from "./OrderOfferMap.vue?vue&type=script&lang=js"
export * from "./OrderOfferMap.vue?vue&type=script&lang=js"
import style0 from "./OrderOfferMap.vue?vue&type=style&index=0&id=5b4ba8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ba8d8",
  null
  
)

export default component.exports